import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import OldButton from '../../b2b/components/button/button';
import Contact from '../contact/contact';
import { ReactComponent as CancelledSvg } from '/src/assets/svg/lease-application-cancel.svg';
import { ReactComponent as CancelledSmallSvg } from '/src/assets/svg/small_error.svg';

const StatusUndefined: React.FC = () => {
  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <CancelledSmallSvg className='status-svg mb-6' />
      )}
      <div>Etwas ist schiefgelaufen</div>
    </>
  );

  return (
    <Layout
      heading={headline}
      subHeading='Beim Aufrufen dieser Seite ist ein technischer Fehler aufgetreten. Bitte versuche es erneut.'
      hasFullSize={true}
      className='status-overview top-96 grid'
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <div
        className='half-half-columns cancelled top-36'
        style={{ alignItems: 'start' }}
      >
        {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
          <CancelledSvg className='status-svg' />
        )}
        <div className='flex flex-col gap-4'>
          <div className='content-bold'>Was du jetzt tun kannst</div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Lade die Seite neu.',
              'Sollte der Fehler weiterhin auftreten, hilft dir unser Service-Team gerne weiter.',
            ]}
          />

          <div className='content-bold'>Dein Konto bleibt erhalten</div>
          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Deine Registrierung bleibt bestehen. Du kannst dich ganz einfach mit deinen Daten anmelden.',
            ]}
          />
          <OldButton
            type='button'
            onClick={() => window.location.reload()}
            style={{
              width: '100%',
              marginTop: '18px',
              marginBottom: '18px',
            }}
          >
            <span className='content-bold text-base!'>Seite neu laden</span>
          </OldButton>

          <Contact />
        </div>
      </div>
    </Layout>
  );
};

export default StatusUndefined;
